











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  containingSpacesPattern,
  passwordPattern,
  MAX_LENGTH,
  OnValidatedCallback
} from '../../types/constants';
import InputField from '@/components/auth-form/InputField.vue';

@Component({
  components: { InputField }
})
export default class PasswordField extends Vue {
  @Prop() name!: string;

  @Prop() placeholder!: string;

  @Prop() autocomplete!: string;

  @Prop({ type: String, default: '' }) value!: string;

  @Prop({ type: Boolean, default: false }) enableRequirements?: boolean;

  inputValue: string = this.value;

  passwordVisible: boolean = false;

  passwordMaxLength = MAX_LENGTH.PASSWORD;

  passwordPattern = () => /.+/g;

  created() {
    if (this.$parent) {
      this.$parent.$on(`validate:${this.name}`, (done: OnValidatedCallback) => {
        this.$emit(`validate:${this.name}`, done);
      });
    }
  }

  @Watch('inputValue')
  setValue() {
    this.$emit('update:value', this.inputValue);
  }

  validatePassword() {
    if (this.enableRequirements) {
      return !this.isContainingSpaces && this.isPasswordMatchPattern;
    }

    return true;
  }

  get passwordInputType() {
    return this.passwordVisible ? 'text' : 'password';
  }

  get isContainingSpaces() {
    return containingSpacesPattern().test(this.inputValue);
  }

  get isPasswordMatchPattern() {
    return passwordPattern().test(this.inputValue);
  }
}
